import * as React from 'react';
import { Avatar, Table, Row, Card, Col } from 'antd';
import { PointReward, Merchant } from 'src/store';
import { Subscription } from 'rxjs';
import { Query, DocumentReference } from '@firebase/firestore-types';
import * as firebase from 'firebase/app';
import { ColumnProps } from 'antd/lib/table';
import { snapShot$, querySnapShot$ } from 'src/util';

interface Props {
    merchantId?: string | null;
}

interface S {
    merchant: Merchant;
    data: PointReward[];
    loading?: boolean;
    currentPage: number;
}

class Points extends React.Component<Props, S> {
    subscription: Subscription;
    columns: ColumnProps<PointReward>[];
    merchantRef: DocumentReference;
    pointRewardsRef: Query;
    pageSize: number;
    constructor(props: Props) {
        super(props);

        this.subscription = new Subscription();
        const { merchantId } = this.props;
        this.pageSize = 10;
        this.state = { merchant: {} as Merchant, data: [], loading: false, currentPage: 1 };
        this.merchantRef = firebase.firestore().doc(`merchants/${merchantId}`);
        this.pointRewardsRef = firebase.firestore().doc(`merchants/${merchantId}`)
            .collection('pointRewards')
            .orderBy('point', 'asc');
    }

    componentDidMount() {
        // this.handlePageChange(1);
        this.setState({ loading: true });
        const doc$ = snapShot$(this.merchantRef).switchMap(sn => {
            const merchant = sn.data() as Merchant;
            return querySnapShot$(this.pointRewardsRef).map(prSn => {
                const result = prSn.empty ?
                    [] as PointReward[] :
                    prSn.docs.map(d => ({ ...d.data(), id: d.id }) as PointReward);
                return { merchant, data: result };
            });
        });
        this.subscription.add(doc$.subscribe(({ merchant, data }) => {
            this.setState({ merchant, data, loading: false, });
        }));
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    getDataSource = () => {
        const { data, loading, currentPage } = this.state;
        const page = loading ? 1 : currentPage;
        const ds = !loading ?
            data.map((obj, i) => ({
                // no: ((page - 1) * this.pageSize) + (i + 1),
                no: i + 1,
                key: obj.id,
                ...obj,
            })) : [];

        return {
            ds,
            page,
        };
    }
    render() {
        const { ds } = this.getDataSource();
        const { merchant: { pointSystem }, loading } = this.state;

        this.columns = [{
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            width: "5%",
            render: (text: string, record: PointReward, index: number) => {
                return <span>{record.no}</span>;
            }
        },
        {
            title: 'Image',
            dataIndex: 'photo',
            key: 'photo',
            width: "10%",
            // tslint:disable-next-line:no-any
            render: (text: string, record: PointReward) => (
                <span>
                    <Avatar
                        src={record.photo}
                        className="img-circle"
                    />
                </span>
            )
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
        },
        {
            title: 'Point',
            dataIndex: 'point',
            key: 'point',
            width: '20%',
        },
        {
            title: 'Expire In Month',
            dataIndex: 'expireInMonth',
            key: 'expireInMonth',
            width: '15%',
        },
            // {
            //     title: 'Created',
            //     // dataIndex: 'creat',
            //     width: '15%',
            //     // tslint:disable-next-line:no-any
            //     render: (text: string, record: any) => {
            //         return <DisplayDate dateTime={record.createdOn} />
            //     }
            // },
            // {
            //     title: 'Signed In',
            //     dataIndex: 'creat',
            //     key: 'loginUserName',
            //     width: '15%',
            //     // tslint:disable-next-line:no-any
            //     render: (text: string, record: any) => {
            //         return <DisplayDate dateTime={record.metadata.lastSignInTime} />
            //     }
            // }
        ];
        return (
            <Row>
                <Card
                    // title={title}
                    bordered={true}
                    style={{ marginBottom: 10 }}
                    loading={loading}
                >
                    <Row>
                        <Col span={8}>
                            <span className="ant-form-text">{`1 Point = ${pointSystem ? pointSystem.exchangeRate : 100} MMK`}</span>
                        </Col>

                    </Row>

                </Card>
                <Table
                    loading={loading}
                    columns={this.columns}
                    dataSource={ds}
                    // onRow={this.handleOnRow}
                    pagination={{
                        // current: page || 0,
                        // pageSize: this.pageSize,
                        // total: ds.length || 0,
                        // onChange: this.handlePageChange,
                        showTotal: (total) => <span className="total-count">Total Count: {total}</span>
                    }}
                    size="middle"
                    bordered={true}
                />
            </Row>
        );
    }
}

export default Points;



// WEBPACK FOOTER //
// ./src/merchants/forms/Points.tsx